export const PLAYLIST_CREATOR_SIDEBAR_NAME = 'review-playlist-creator';
export const PLAYLIST_EDITOR_SIDEBAR_NAME = 'review-playlist-editor';

export const PLAYLIST_SIDEBAR_NAMES = [
    PLAYLIST_CREATOR_SIDEBAR_NAME,
    PLAYLIST_EDITOR_SIDEBAR_NAME,
] as const;

export type PlaylistSidebarName = typeof PLAYLIST_SIDEBAR_NAMES[number];
